import { createAction } from '@reduxjs/toolkit';

export const resetAction = createAction('RESET');
